var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ClientList',{attrs:{"local-client":_vm.localClient,"node-id":_vm.$route.params.node_id}})
}
var staticRenderFns = []

export { render, staticRenderFns }